import { useEffect, useState } from "react";

import { InputSuffix } from "#components/atoms/InputSuffix/InputSuffix";
import { centsToEuro, euroToCents, parseInputNumberValue } from "#shared/helpers/prices";

const PRICE_UNIT = "€/kg";

const formatEuroInput = (cents: number): string => String(centsToEuro(cents)).replace(".", ",");

type PriceCellProps = {
  value: number;
  ariaLabel: string;
  onUpdate: (value: number) => void;
};

export const PriceCell = ({ value, ariaLabel, onUpdate }: PriceCellProps) => {
  const [inputValue, setInputValue] = useState(formatEuroInput(value));

  useEffect(() => setInputValue(formatEuroInput(value)), [value]);

  const handleBlur = () => {
    const euros = parseInputNumberValue(inputValue);
    if (Number.isNaN(euros) || euros < 0) {
      setInputValue(formatEuroInput(value));
      return;
    }

    const cents = euroToCents(euros);
    if (cents !== value) {
      onUpdate(cents);
    }
  };

  return (
    <InputSuffix
      value={inputValue}
      onChange={setInputValue}
      onBlur={handleBlur}
      suffix={PRICE_UNIT}
      aria-label={ariaLabel}
    />
  );
};
